// 应用全局配置，所有配置统一管理，避免环境配置重复

// 从环境变量获取配置
const env = import.meta.env

// API配置
export const API_CONFIG = {
  // API基础路径（App端，/api/app 或 /prod-api/app）
  BASE_URL: env.VITE_API_BASE_URL,
  // Admin API基础路径（后台端，/api 或 /prod-api），用于H5调用后台已有接口
  API_URL: env.VITE_API_API_URL,
  // API基础域名
  BASE_DOMAIN: env.VITE_API_BASE_DOMAIN,
  // API超时时间
  TIMEOUT: Number(env.VITE_API_TIMEOUT),
  // 媒体资源URL
  MEDIA_URL: env.VITE_API_MEDIA_URL,
}

// 应用信息（集中管理，各页面统一引用，避免硬编码散落）
export const APP_INFO = {
  // 应用名称
  NAME: 'CRM客资跟进',
  // 应用标语
  SLOGAN: '高效管理客户，精准跟进转化',
  // 版本号（从环境变量读取，方便打包时切换）
  VERSION: env.VITE_APP_VERSION || '1.0.0',
  // ICP备案号（从环境变量读取）
  ICP: env.VITE_APP_ICP || '',
  // ICP备案查询地址
  ICP_URL: 'https://beian.miit.gov.cn/',
  // 版权信息
  COPYRIGHT: '© 2025 CRM客资跟进系统',
  // 联系方式
  CONTACT: {
    EMAIL: 'admin@huanxiji.com',
    WECOM: '通过企微工作台联系管理员',
  },
  // 功能介绍
  FEATURES: [
    { icon: 'friends-o', color: '#1989fa', text: '客户管理：分配、跟进、转化全流程' },
    { icon: 'bell', color: '#ff976a', text: '消息通知：企微推送，及时响应' },
    { icon: 'todo-list-o', color: '#ee0a24', text: '订单审核：订单状态实时跟踪' },
    { icon: 'chart-trending-o', color: '#07c160', text: '数据统计：业绩一览，掌握全局' },
  ],
  // 产品介绍
  DESCRIPTION: 'CRM客资跟进系统是一款专注于婚宴行业客户关系管理的移动端工具，帮助客服团队高效跟进客户、提升转化率。',
  DESCRIPTION_EXTRA: '系统提供客户分配、跟进记录、订单审核、消息通知等核心功能，让客户管理更加规范、透明、高效。',
}

// 应用配置
export const APP_CONFIG = {
  // 应用标题
  TITLE: env.VITE_TITLE,
  // 登录相关配置
  login: {
    // 是否使用弹窗方式登录，true使用弹窗，false使用页面跳转
    usePopup: true
  }
}

// 环境配置
export const ENV_CONFIG = {
  // 环境名称
  NAME: env.VITE_ENV,
  // 是否为开发环境
  IS_DEV: env.VITE_ENV === 'dev',
  // 是否为生产环境
  IS_PROD: env.VITE_ENV === 'prod'
}

// 分页配置
export const PAGE_CONFIG = {
  // 默认第几页
  PAGE_NUM: 1,
  // 分页每页数量
  PAGE_SIZE: 10,
  // 分页每页数量数组
  PAGE_ARRAY: [10, 20, 50, 100, 500, 1000]
}